<template>
  <SuggestPart
      item-value="id"
      :item-text="(Item) => {
        return this.$moment(Item.paidAt).format('DD.MM.YYYY') + ' - ' + Item.title + ' (' + this.$options.filters.currency(Item.balance, '€') + ')'
      }"
      itemsKey="expenses"
      :fetchData="fetchData"
      v-bind="$attrs"
      v-on="$listeners"
  />
</template>

<script>
  import Expenses from '@/services/expenses'

  import SuggestPart from '@/components/_Part/Suggest'

  export default {
    name: 'SuggestOnlyAlertBalance',
    components: {
      SuggestPart
    },
    methods: {
      fetchData() {
        return Expenses
          .suggestOnlyAlertBalance()
      }
    }
  }
</script>
